import React, { ReactNode } from "react";
import { Route } from "react-router-dom";
import { RouteType } from "./config";
import appRoutes from "./appRoutes";
import Wrapper from "../layout/Wrapper";

const generateRoute = (routes: RouteType[]): ReactNode => {
  return routes.map((route, index) =>
    route.index ? (
      <Route
        index
        path={route.path}
        element={<Wrapper state={route.state}>{route.element}</Wrapper>}
        key={index}
      />
    ) : (
      <Route
        path={route.path}
        element={
          <Wrapper state={route.state ?? undefined}>{route.element}</Wrapper>
        }
        key={index}
      >
        {route.child && generateRoute(route.child)}
      </Route>
    )
  );
};

export const routes: ReactNode = generateRoute(appRoutes);
